/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 */
export enum OrderInspectionStatus {
  DATA_ENTRY = 'data_entry',
  INSPECTION = 'inspection',
  OFFER_READY = 'offer_ready',
}
